/* eslint-disable @reatom/unit-naming-rule */
import { atom } from '@reatom/framework'
import { match } from 'ts-pattern'

import type { OrderModel } from '../atoms'
import type { DefaultTheme } from 'styled-components'

export const statusColor = (order: OrderModel, theme: DefaultTheme) => {
  return atom((ctx) => {
    return match(order)
      .with({ type: 'limit' }, ({ order }) =>
        match(ctx.spy(order.status))
          .returnType<string>()
          .with('active', () => theme.palette.primary[9])
          .with('cancelled', () => theme.palette.error[9])
          .with('completed', () => theme.palette.success[9])
          .with('failed', () => theme.palette.error[9])
          .with('expired', () => theme.palette.error[9])
          .exhaustive(),
      )
      .with({ type: 'market' }, ({ order }) =>
        match(ctx.spy(order.status))
          .returnType<string>()
          .with('active', () => theme.palette.primary[9])
          .with('failed', () => theme.palette.error[9])
          .with('finished', () => theme.palette.success[9])
          .exhaustive(),
      )
      .exhaustive()
  })
}
